<template>
  <div v-if="message.quickReply">
    <div class="clearfix"></div>
    <div class="mt-2 mb-3">
      <template v-for="(item, index) in message.quickReply.items">
        <button class="btn btn-sm m-1"
                :class="item.style"
                @click="checkMessage(item)">{{ item.text }}
        </button>
      </template>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'

  export default {
    props: {
      message: Object
    },
    computed: {
      ...mapGetters({
        user: 'auth/getUser'
      }),
      ...mapState('chatBooking', ['bookingData'])
    },
    methods: {
      checkMessage (item) {
        if (item.label === 'selected-service' || item.label === 'selected-service-request') {
          const urlParams = new URLSearchParams(item.data)
          const params = Object.fromEntries(urlParams)
          if (this.bookingData.service_id && this.bookingData.service_id !== params.service_id && this.bookingData.route === 'new-booking') {
            this.$swal({
              text: 'คุณต้องการเปลี่ยนบริการใช่หรือไม่ สำหรับการเปลี่ยนบริการ คุณจำเป็นต้องเริ่มทำการจองใหม่',
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#9E9E9E',
              reverseButtons: true,
              confirmButtonText: this.$i18n.t('message.confirm.yes'),
              cancelButtonText: this.$i18n.t('message.confirm.cancel')
            }).then(() => {
              // Clear all messages and start new booking
              if (this.user) {
                this.$store.commit('chatBooking/INIT_MESSAGE', this.user)
              } else {
                this.$store.commit('chatBooking/INIT_MESSAGE', null)
              }
            })
          } else {
            this.sendMessage(item)
          }
        } else {
          this.sendMessage(item)
        }
      },
      sendMessage (item) {
        const itemType = item.type
        switch (itemType) {
          case 'message':
            const message = {
              sender_type: 'user',
              type: 'text',
              label: item.label,
              text: item.text,
              data: item.data
            }
            if (item.optional_text) {
              message.optional_text = item.optional_text
            }
            this.$store.commit('chatBooking/ADD_MESSAGE', message)
            break
          case 'uri':
            window.open(item.uri, '_blank')
            break
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/chatBooking/components/QuickReply.vue